export const navigationMenuBaseItemStyles = [
  'relative',
  'text-(--text)',
  'outline-none',
  'cursor-pointer',
  'font-body',
  'select-none',
  'p-3',
  'rounded-md',
  'bg-(--background)',
  'hover:bg-(--background-hover)',
  'hover:text-(--text-hover)',
  'active:bg-(--background-active)',
  'active:text-(--text-active)',
  'focus-visible:inset-shadow-[0_0_0_2px_var(--color-primary-800)]',
  'disabled:bg-none',
  'disabled:cursor-default',
  'disabled:opacity-[30%]',
  'disabled:text-(--text)'
]

export const navigationMenuActiveItemStyles = [
  'font-semibold',
  'text-item-(--background-selected)',
  'after:-translate-x-1/2',
  'after:absolute',
  'after:bg-item-(--background-selected)',
  'after:block',
  'after:bottom-0',
  'after:h-0.5',
  'after:left-1/2',
  'after:rounded-md',
  'after:translate-y-0',
  'after:w-6'
]
